const orderTypeEnum = Object.freeze({
  SCHEDULED: 'scheduled',
  INSTANT: 'instant',
});

export default orderTypeEnum;
